import { render } from "./GlobalFooter.vue?vue&type=template&id=e0f8bee2"
import script from "./GlobalFooter.vue?vue&type=script&lang=js"
export * from "./GlobalFooter.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./GlobalFooter.vue?vue&type=style&index=0&id=e0f8bee2&lang=scss&module=s"
cssModules["s"] = style0

import exportComponent from "/usr/share/nginx/production/frontend/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__